import Typist from 'react-typist';

import './home.styles.scss';

const Home = () => {
	return (
		<div className="home">
			<div id="stars" />
			<div className="text-center container">
				<h1 className="display-1">Nam Nguyen</h1>
				<Typist className="lead typist" cursor={{ show: false }}>
					Hi! I'm a software engineer with a self-starter's mindset.
				</Typist>
				<div className="p-5">
					<a
						target="_blank"
						rel="noopener noreferrer"
						aria-label="My github"
						href="https://github.com/ironhight"
					>
						<i className="fab fa-github fa-3x socialicons" />
					</a>
					<a
						target="_blank"
						rel="noopener noreferrer"
						aria-label="My facebk"
						href="https://github.com/ironhight"
					>
						<i className="fab fa-facebook fa-3x socialicons" />
					</a>
					<a
						target="_blank"
						rel="noopener noreferrer"
						aria-label="My instag"
						href="https://github.com/ironhight"
					>
						<i className="fab fa-instagram fa-3x socialicons" />
					</a>
					<a
						target="_blank"
						rel="noopener noreferrer"
						aria-label="My linked"
						href="https://github.com/ironhight"
					>
						<i className="fab fa-linkedin fa-3x socialicons" />
					</a>
					<a
						target="_blank"
						rel="noopener noreferrer"
						aria-label="My twitter"
						href="https://github.com/ironhight"
					>
						<i className="fab fa-twitter fa-3x socialicons" />
					</a>
				</div>
				<a
					className="btn btn-outline-light btn-lg"
					role="button"
					aria-label="Learn more about me"
					href="https://github.com/ironhight"
					target="_blank"
					rel="noopener noreferrer"
				>
					More about me
				</a>
				<div className="footer">
					<i className="fas fa-code" /> with <i className="fas fa-heart" />
					{''} by
					<a
						className="badge badge-dark socialicons"
						rel="noopener noreferrer"
						href="https://github.com/ironhight"
						aria-label="My GitHub"
					>
						Ironhight
					</a>
				</div>
			</div>
		</div>
	);
};

export default Home;
